import { applyFieldPatches, mapOptions } from './utility';

export const mapFacilityTypeOptions = (items = []) => {
  return mapOptions(items, (key) => ({
    value: key.facility_type,
    label: key.facility_type,
    id: key.facility_type_id,
    code: key.facility_type_code,
  }));
};

export const mapFacilityOptions = (items = [], extraMapper) => {
  return mapOptions(items, (key) => ({
    value: key.facility_name,
    label: key.facility_name,
    id: key.facilit_id ?? key.facility_id,
    code: key.facility_code,
    fac_type_id: key.facility_type_id,
    hfr_id: key.hfr_id,
    ...(typeof extraMapper === 'function' ? extraMapper(key) : {}),
  }));
};

export const mapTaggedUserOptions = (items = []) => {
  return mapOptions(items, (key) => ({
    value: `${key.f_name} ${key.l_name}`,
    label: `${key.f_name} ${key.l_name}`,
    id: key.user_id,
    code: key.user_code,
  }));
};

export const applyFacilityNameOptions = ({
  facilityOptions,
  setInitialFacilityNames,
  setfacilityFormData,
  setfieldFormData,
}) => {
  setInitialFacilityNames({ facilityOptions });
  setfacilityFormData((facilityFormData) => applyFieldPatches(facilityFormData, {
    health_facility_name: {
      '#options': facilityOptions,
    },
  }));
  setfieldFormData((fieldFormData) => applyFieldPatches(fieldFormData, {
    health_facility_name: {
      '#options': facilityOptions,
    },
  }));
};

export const getFacilityTypeNameById = (facilityTypeOptions = [], facilityTypeId) => {
  return facilityTypeOptions.find((item) => item.id === facilityTypeId)?.value || '';
};

export const getFacilityTypeValueById = (facilityTypeOptions = [], facilityTypeId) => {
  return facilityTypeOptions.find((option) => option.id === facilityTypeId)?.value || '';
};

export const getSelectedFacilityMeta = (options = [], id) => {
  const selectedFacility = Array.isArray(options)
    ? options.find((option) => String(option?.id) === String(id))
    : undefined;

  return {
    selectedFacility,
    facilityTypeId: selectedFacility?.fac_type_id,
    hfrId: selectedFacility?.hfr_id ?? '',
  };
};

export const getSingleFacilityNameOptions = (option) => {
  if (!option) return [];
  return [
    {
      value: `${option?.facility_name}`,
      label: `${option?.facility_name}`,
      id: `${option?.facilit_id}`,
      code: '',
    },
  ];
};

export const getFacilityTypeSelectionPatch = (selectedFacilityType = '') => ({
  health_facility_type: {
    value: selectedFacilityType,
  },
});

export const getHfrStatePatch = (hfrID = '') => ({
  hfr_id: {
    value: hfrID || '',
  },
});

export const getHfrVerifyPatch = (hfrID = '') => ({
  hfrId: {
    '#isDisabled': !!hfrID,
  },
});

export const getHealthFacilityNameSelectionPatch = (option) => ({
  health_facility_name: {
    value: option?.facility_name,
    id: option?.facilit_id,
  },
});
